const state = () => ({
    tabGroups: [] 
  });
  
  export default state;